import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import { revalidateCustomerLeads } from "@richbeauty/utility/helper/cacheRevalidator";
import { toast } from "react-hot-toast";
import { useIntl } from "react-intl";
import useSWRMutation from "swr/mutation";

const importFile = async ({ file }) => {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  const formData = new FormData();
  formData.append("file", file);
  return jwtAxios.post(URL_API.CMS_CUSTOMER_LEADS.IMPORT, formData, config);
};

const useImportCustomerLead = () => {
  const { formatMessage } = useIntl();
  const fetcher = (url, { arg }) => importFile(arg);

  return useSWRMutation(URL_API.CMS_CUSTOMER_LEADS.IMPORT, fetcher, {
    onSuccess: () => {
      toast.success(formatMessage({ id: "common.importFileSuccess" }));
      revalidateCustomerLeads();
    },
    onError: (e) => {
      e?.message
        ? toast.error(e?.message)
        : toast.error(formatMessage({ id: "common.importFileFail" }));
    },
  });
};

export default useImportCustomerLead;
